import { render } from "./NotificationCenter.vue?vue&type=template&id=598a5bf0"
import script from "./NotificationCenter.vue?vue&type=script&lang=js"
export * from "./NotificationCenter.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NotificationCenter.vue"]])

export default __exports__